module.exports = __webpack_public_path__ + "img/reply-icon.5657f4c3.svg";